export const columns = [
  {
    title: "系统名称",
    width: 150,
    key: "systemName",
    slots: { customRender: "systemName" },
  },
  {
    title: "材料编号",
    width: 150,
    key: "materialNo",
    dataIndex: "materialNo",
  },
  {
    title: "材料名称",
    width: 200,
    key: "materialName",
    dataIndex: "materialName",
  },
  {
    title:"规格型号",
    width:150,
    key:"materialModel",
    dataIndex:"materialModel"
  },
  {
    title:"品牌",
    width:150,
    key:"materialBrand",
    dataIndex:"materialBrand"
  },
  {
    title:"结算单位",
    width:150,
    key:"materialUnit",
    dataIndex:"materialUnit"
  },
  {
    title:"关联PO单",
    width:150,
    key:"purchaseOrderNo",
    dataIndex:"purchaseOrderNo"
  }, 
  {
    title:"所属项目",
    width:150,
    key:"projectName",
    dataIndex:"projectName"
  },
  {
    title: "所在仓库",
    width: 150,
    key: "repertotyName",
    dataIndex: "repertotyName",
  },
  {
    title: "库存数量",
    width: 150,
    key: "count",
    dataIndex: "count",
  },
  {
    title: "库存质量",
    width: 150,
    key: "storageQualityName",
    dataIndex: "storageQualityName",
  },
  {
    title: "批次号",
    width: 150,
    key: "batchBizNo",
    dataIndex: "batchBizNo",
  },
  {
    title: "供应商",
    width: 150,
    key: "supplierName",
    dataIndex: "supplierName",
  },
  {
    title: "单个采购成本",
    width: 150,
    key:"taxPrice",
    slots: { customRender: "taxPrice" },
  },
  {
    title: "入库日期",
    width: 150,
    key: "putDate",
    dataIndex: "putDate",
  },
];
